function heap_identify() {

    const cmsCookie = Cookies.get('CmsCookie');

    if (cmsCookie != null && cmsCookie.length > 0) {

		var cmsCookieParsed = JSON.parse(decodeURIComponent(cmsCookie));

        const usa_account_id = cmsCookieParsed.AccountId;

        if (usa_account_id) {

            heap.identify(usa_account_id);

            const addUserPropertiesWithRetry = () => {

                setTimeout(() => {

                    let heap_id = heap.getUserId();
        
                    if (!heap_id) {

                        addUserPropertiesWithRetry();

                    } else {

                        heap.addUserProperties({ Email: usa_account_id });

                    }

                }, 10);

            };

            addUserPropertiesWithRetry(); // retry until the heap user ID is set

        }       

    }

}